import actions from './constants';

export const updateRequestDictionaries = (category, code, codes) => ({
  type: actions.UPDATE_REQUEST_DICTIONARIES,
  category,
  code,
  codes,
});

export const fetchRequestCatalogue = (category, code, datasetCode) => ({
  type: actions.FETCH_REQUEST_CATALOGUE,
  category,
  code,
  datasetCode,
});

export const fetchRequestDatasetSettings = (category, code, datasetCode) => ({
  type: actions.FETCH_REQUEST_DATASET_SETTINGS,
  category,
  code,
  datasetCode,
});

export const fetchRequestDictionaries = (category, code, datasetCode) => ({
  type: actions.FETCH_REQUEST_DICTIONARIES,
  category,
  code,
  datasetCode,
});

export const datasetSettingsToRequest = (category, code, settings, namespaces, status, workflow) => ({
  type: actions.DATASET_SETTINGS_TO_REQUEST,
  category,
  code,
  settings,
  workflow,
  namespaces,
  status,
});

export const dictionariesToRequest = (category, code, result) => ({
  type: actions.DICTIONARIES_TO_REQUEST,
  category,
  code,
  result,
});

export const datasetToRequestError = (category, code, error) => ({
  type: actions.DATASET_TO_REQUEST_ERROR,
  category,
  code,
  error,
});

export const fetchRequestDatasets = (category, code, page, pageSize, append) => ({
  type: actions.FETCH_REQUEST_DATASETS,
  category,
  code,
  page,
  pageSize,
  append,
});

export const updateRequestDatasetsFilter = (category, code, value) => ({
  type: actions.UPDATE_REQUEST_DATASETS_FILTER,
  category,
  code,
  value,
});

export const toggleRequestDatasetSelected = (category, code, datasetCode) => ({
  type: actions.TOGGLE_REQUEST_DATASET_SELECTED,
  category,
  code,
  datasetCode,
});

export const updateRequestDatasetsFlags = (category, code, { privateFlag, internalFlag, publicFlag }) => ({
  type: actions.UPDATE_REQUEST_DATASETS_FLAGS,
  category,
  code,
  privateFlag,
  internalFlag,
  publicFlag,
});

export const showRequestDatasets = (
  category,
  code,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
) => ({
  type: actions.SHOW_REQUEST_DATASETS,
  category,
  code,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
});

export const catalogueToRequest = (category, code, result) => ({
  type: actions.CATALOGUE_TO_REQUEST,
  category,
  code,
  result,
});
